import { render, staticRenderFns } from "./ClientResource.vue?vue&type=template&id=70529abc&"
import script from "./ClientResource.vue?vue&type=script&lang=js&"
export * from "./ClientResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports